class Login extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.recoveryForm = this.element.querySelector("#ForgotPass");
    this.loginForm = this.element.querySelector("#logIn");

    if (window.location.href.indexOf("recover") != -1) {
      this.openRecover();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
        "click",
        '[data-action="toggle-recovery"]',
        this.openRecover.bind(this)
    );
    this.delegateElement.on(
        "click",
        '[data-action="toggle-login"]',
        this.openLogin.bind(this)
    );

    this.delegateElement.on(
      'click', 
      '[data-action="submit-register"]', 
      this.submitRegistration.bind(this)
    );

    this.delegateElement.on(
      'click', 
      '[data-action="submit-login"]', 
      this.submitLogin.bind(this)
    );

    this.delegateElement.on("keypress", '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));
  }

  connectedCallback() {
    this.initFormValidation();
  }

  openRecover(event = null) {
    if (event) event.preventDefault();
    this.recoveryForm.setAttribute('aria-hidden', 'false');
    this.loginForm.setAttribute('aria-hidden', 'true');
  }

  openLogin(event = null) {
    if (event) event.preventDefault();
    this.recoveryForm.setAttribute('aria-hidden', 'true');
    this.loginForm.setAttribute('aria-hidden', 'false');
  }

  initFormValidation() {
    const forms = {
      login: { el: "#customer_login", button: ".acc_login-btn", error: ".input-validation" },
      register: { el: "#register_form", button: ".acc_login-btn, .Button--auth", error: ".registerErrors" },
      recover: { el: "#recover_form", button: ".acc_forgot-btn", error: "#RecoverEmail-email-error" },
      reset: { el: "#reset_form", button: ".acc_reset-btn", error: ".input-validation" },
      activate_account: { el: "#activate-account", button: ".activate-account__submit", error: ".input-validation" }
    };

    for (const [key, { el, button, error }] of Object.entries(forms)) {
      const form = this.querySelector(el);
      if (!form) continue;

      this[`${key}Validator`] = new FormValidator(form, {
        errorClass: "field--error",
        fieldSelector: ".field",
        buttonSelector: button,
        fieldErrorSelector: error,
        validateOnBlur: true,
        validateOnInput: false,
        showErrorsOnSubmitOnly: false
      });
    }
  }

  async submitRegistration(event) {
    event.preventDefault();

    const registrationEndpoint = `${window.routes.localeRootUrl}/account`;

    const form = event.target.closest("form");

    const firstNameInput = form.querySelector("#RegisterForm-FirstName");
    const lastNameInput = form.querySelector("#RegisterForm-LastName");
    const emailInput = form.querySelector("#RegisterForm-email");
    const passwordInput = form.querySelector("#RegisterForm-password");

    const emailField = emailInput.closest(".field");
    const passwordField = passwordInput.closest(".field");

    const loader = form.querySelector(".itemLoader");

    // Reset previous errors
    form.querySelectorAll(".registerErrors").forEach(el => el.remove());
    [emailField, passwordField].forEach(f => f?.classList.remove("input--error"));
    [emailInput, passwordInput].forEach(i =>
      i.setAttribute("aria-invalid", "false")
    );

    loader?.classList.add("is-visible");

    const requestBody = {
      customer: {
        first_name: firstNameInput.value,
        last_name: lastNameInput.value,
        email: emailInput.value,
        password: passwordInput.value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    try {
      const response = await fetch(registrationEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const finalPath = new URL(response.url, window.location.origin).pathname.replace(/\/+$/, "");
      const stayedOnRegister = finalPath === "/account/register";

      if (stayedOnRegister) {
        emailInput.setAttribute("aria-invalid", "true");
        emailField.classList.add("input--error");

        const error = document.createElement("span");
        error.id = "RegisterForm-email-error";
        error.className = "u-p5 AlertError formError registerErrors";
        error.innerHTML = window.languages.account_already_exists;

        emailField.after(error);
        return;
      }

      // ✅ Success
      location.href = window.routes.account_url;

    } catch (err) {
      console.error("Registration error:", err);

      const error = document.createElement("span");
      error.className = "u-p5 AlertError formError registerErrors";
      error.innerHTML = "Something went wrong. Please try again.";

      passwordField.after(error);
    } finally {
      loader?.classList.remove("is-visible");
    }
  }

  async submitLogin(event) {
    event.preventDefault();
    const loginEndpoint = `${window.routes.localeRootUrl}/account/login`;
    const requestBody = {
      customer: {
        email: this.element.querySelector("#CustomerEmail").value,
        password: this.element.querySelector("#CustomerPassword").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loginButton = this.element.querySelector('[data-action="submit-login"]');
    console.log(loginButton, " login button ");
    const loader = loginButton ? loginButton.querySelector(".itemLoader") : null;
    console.log(loader, " loader ");
    loader.classList.add("is-visible");

    try {
      const response = await fetch(loginEndpoint, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("loginError")) {
        const loginError = this.element.querySelector("#login .accountDrawer--ErrorSpace");
        loginError.innerHTML = "";
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;
        loginError.innerHTML = tempDiv.querySelector(".AlertError").innerHTML;
        loginError.classList.add("is-visible");

        const fieldErr = loginError.closest('.field');
        if (fieldErr) fieldErr.classList.add('input--error');
      } else {
        location.href = window.routes.account_url;
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      loader.classList.remove("is-visible");
    }
  }

  accountInputSubmit(e) { if (e.key === "Enter") this.submitLogin(e); }
  accountInputSubmitReg(e) { if (e.key === "Enter") this.submitRegistration(e); }
  accountInputSubmitForgot(e) { if (e.key === "Enter") { e.preventDefault(); this.accountRecover(e); } }

}

customElements.define("customer-login", Login);

class AccountComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.delegateBody = new Delegate(document.body);

    this.stickyAddNewWrapper = this.element.querySelector('.customer-account__add-new-sticky');
    this.addNewBtn = this.element.querySelector('.customer-account__add-new');

    this._cleanupFunctions = [];

    this.bindEvents();
  }

  connectedCallback() {
    // this.initFormValidation();
    this.handleRefreshState();
  }

  disconnectedCallback() {
    this._cleanupFunctions.forEach(cleanup => cleanup());
    this._cleanupFunctions = [];
  }

   debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  bindEvents() {
    this.delegateBody.on("drawer:open", this.formValidationOn.bind(this));

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on("click", '[data-action="delete-address"]', this.deleteAddress.bind(this));

    if (this.stickyAddNewWrapper) {
      scrollListener.addScrollListener(this, this.showStickyAddNew.bind(this));
    }

    this.delegateElement.on(
        "click",
        '[data-action="set-default-address"]',
        this.handleDefaultButton.bind(this)
    )
  }


  handleDefaultButton(e){
    e.preventDefault();
   e.target.classList.toggle("is-active");

   e.target.closest("form").submit();
  }
  formValidationOn (event) {

    const id = event.detail.drawerId
    this.initFormValidation(id)
  }

  initFormValidation(id) {

    const addressId = id.split("edit-address-")[1];
    const forms = {
      edit_customer: {el: "#edit-info", button: ".edit-info", error: ".input-validation"},
      add_address: { el: "#add-address", button: ".add-address-btn", error: ".input-validation" },
      edit_address: { el: `#edit-address-form-${addressId}`, button: `.edit-address-btn-${addressId}`, error: ".input-validation" }
    };

    for (const [key, { el, button, error }] of Object.entries(forms)) {


      let form = this.querySelector(el);

      if (!form) continue;

      this[`${key}Validator`] = new FormValidator(form, {
        errorClass: "field--error",
        fieldSelector: ".field",
        buttonSelector: button,
        fieldErrorSelector: error,
        validateOnBlur: true,
        validateOnInput: false,
        showErrorsOnSubmitOnly: false
      });
    }
  }


  showStickyAddNew() {
    const options = { root: null, threshold: 0 };
    let mainVisible = false;
    let footerVisible = false;

    const footerEl = document.querySelector('footer');
    const isDebugMode = window.location.search.includes('debug=sticky');

    const updateSticky = this.debounce(() => {
      const shouldHide = mainVisible || footerVisible;
      this.stickyAddNewWrapper.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');

      if (isDebugMode) {
        console.log('🏷️ Sticky ATC:', { mainVisible, footerVisible, shouldHide });
      }
    }, 50);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.target === this.addNewBtn) {
          mainVisible = entry.isIntersecting;
        } else if (entry.target === footerEl) {
          footerVisible = entry.isIntersecting;
        }
      });
      updateSticky();
    }, options);

    if (this.addNewBtn) observer.observe(this.addNewBtn);
    if (footerEl) observer.observe(footerEl);

    this._cleanupFunctions.push(() => observer.disconnect());
  }

  handleRefreshState() {
    if (responsive.matchesBreakpoint('lap_and_up')) {
      const contactInfo = this.element.querySelector('#contactInfo')

          if(contactInfo){
            contactInfo.setAttribute('aria-visible', 'true');
          }
    }

    const searchParams = new URLSearchParams(window.location.search);
    const param1Value = searchParams.get('location');

    if (param1Value) {
      this.toggleTab(false, param1Value);
    } else {
      this.toggleTab(false, 'contactInfo');
    }
  }

  deleteAddress(event) {
    const id = event.target.getAttribute("data-id");
    Shopify.postLink("/account/addresses/" + id, { parameters: { _method: "delete" } });
    setTimeout(() => {
      const currentUrl = new URL(window.location.href);
      window.location.href = currentUrl.href;
    }, 500);
  }


  toggleTab(event, paramValue) {
    let id = paramValue;
    if (event) {
      id = event.target.dataset.id;
    }

    const allContent = this.element.querySelectorAll('.customer-account__content');
    
    let allTabs;
    let activeTab;

    if(!responsive.matchesBreakpoint('lap_and_up')) {
      allTabs = this.element.querySelectorAll('.customer-account__tabs[data-swiper-mobile] .customer-account__tab.swiper-slide');
      activeTab = this.element.querySelector(`.customer-account__tabs[data-swiper-mobile] [data-id="${id}"]`);
    }

    else{
      allTabs = this.element.querySelectorAll('.customer-account__tabs.not_mobile .customer-account__tab');
      activeTab = this.element.querySelector(`.customer-account__tabs.not_mobile [data-id="${id}"]`);
    }

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    if (activeTab) {
      activeTab.setAttribute('aria-expanded', 'true');
      activeTab.classList.add('account-menu_active');
    }

    allContent.forEach((content) => {
        content.setAttribute('aria-visible', 'false');
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }

    const currentUrl = window.location.href.split('?')[0];
    const newUrl = `${currentUrl}?location=${id}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
  }
}

customElements.define("account-component-inner", AccountComponent);

class AccountAddressPopups extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.customerId = this.element.getAttribute('data-customer-id');
  }

  connectedCallback() {
    this.drawerEl = this.element.querySelector('#modal-address-new');
    this.customerInfoDrawer = this.element.querySelector('#edit-customer-info');
    this.editDrawers = this.element.querySelectorAll(
      '.Drawer--wrapper[id^="edit-address-"]'
    );
    this.drawer = new Drawer(this.drawerEl);

    new Drawer(this.customerInfoDrawer)
    this.editDrawers.forEach((elem) => {
      new Drawer(elem);
    });

    this.bindFormHandlers();
  }

  disconnectedCallback() {
    const addAddressForm = this.element.querySelector('#add-address');
    const editAddressForms = this.element.querySelectorAll('form[id^="edit-address-"]');
    const editCustomerForm = this.element.querySelector('#edit-info');

    const allForms = [];
    if (addAddressForm) allForms.push(addAddressForm);
    editAddressForms.forEach(form => allForms.push(form));
    if (editCustomerForm) allForms.push(editCustomerForm);

    allForms.forEach(form => {
      if (form._submitHandler) {
        form.removeEventListener('submit', form._submitHandler);
      }
      if (form._keydownHandler) {
        form.removeEventListener('keydown', form._keydownHandler);
      }
    });
  }

  bindFormHandlers() {
    const addAddressForm = this.element.querySelector('#add-address');
    const editAddressForms = this.element.querySelectorAll('form[id^="edit-address-"]');
    const editCustomerForm = this.element.querySelector('#edit-info');

    const allForms = [];
    if (addAddressForm) allForms.push(addAddressForm);
    editAddressForms.forEach(form => allForms.push(form));

    allForms.forEach(form => {
      form._submitHandler = this.handleAddressSubmit.bind(this);
      form.addEventListener('submit', form._submitHandler);

      form._keydownHandler = this.handleFormKeydown.bind(this);
      form.addEventListener('keydown', form._keydownHandler);
    });

    if (editCustomerForm) {
      editCustomerForm._submitHandler = this.handleCustomerInfoSubmit.bind(this);
      editCustomerForm.addEventListener('submit', editCustomerForm._submitHandler);

      editCustomerForm._keydownHandler = this.handleFormKeydown.bind(this);
      editCustomerForm.addEventListener('keydown', editCustomerForm._keydownHandler);
    }
  }

  async handleCustomerInfoSubmit(event) {
    const form = event.target;

    if (form.dataset.submitting === 'true') {
      return;
    }

    event.preventDefault();
    form.dataset.submitting = 'true';
    this.showLoading(form, true);

    setTimeout(() => {
      form.requestSubmit();
    }, 100);
  }

  handleFormKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const form = event.currentTarget;

      let submitButton = form.querySelector('button[type="submit"]');

      if (!submitButton) {
        // For edit-info form
        submitButton = form.querySelector('button.edit-info');
      }

      if (!submitButton) {
        // For add-address form
        submitButton = form.querySelector('button.add-address-btn');
      }

      if (!submitButton) {
        // For edit-address forms - class starts with "edit-address-btn-"
        submitButton = form.querySelector('button[class*="edit-address-btn-"]');
      }

      if (submitButton) {
        submitButton.click();
      }
    }
  }

  async handleAddressSubmit(event) {
    const form = event.target;

    if (form.dataset.submitting === 'true') {
      return;
    }

    const orgNumberInput = form.querySelector('[name="organization_number"]');

    if (!orgNumberInput) {
      form.dataset.submitting = 'true';
      form.requestSubmit();
      return;
    }

    const orgNumber = orgNumberInput.value.trim();

    event.preventDefault();
    form.dataset.submitting = 'true';
    this.showLoading(form, true);

    try {
      await this.updateOrganizationNumber(orgNumber);

      form.requestSubmit();
    } catch (error) {
      console.error(error);

      this.showError(form, window.orgNumberStrings.error || 'Failed to save organization number');
    } finally {
      this.showLoading(form, false);
      delete form.dataset.submitting;
    }
  }

  async updateOrganizationNumber(orgNumber) {
    const endpoint = `${window.CTEK_BACKEND_API_URL}/api/customer/organization-number`;

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        customerId: this.customerId,
        organizationNumber: orgNumber,
        shop: window.Shopify?.shop
      })
    });

    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = window.routes.account_url || '/account';
        return;
      }

      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to save organization number');
    }

    return response.json();
  }

  showLoading(form, isLoading) {
    const submitButton = form.querySelector('button:has(.itemLoader)');

    if (!submitButton) return;

    const loader = submitButton.querySelector('.itemLoader');

    if (isLoading) {
      submitButton.disabled = true;
      if (loader) loader.classList.add('is-visible');
    } else {
      submitButton.disabled = false;
      if (loader) loader.classList.remove('is-visible');
    }
  }

  showError(form, message) {
    let errorContainer = form.querySelector('.address-form-error');

    if (!errorContainer) {
      errorContainer = document.createElement('div');
      errorContainer.className = 'address-form-error AlertError u-p3 mb-m';
      errorContainer.setAttribute('role', 'alert');

      const formInputs = form.querySelector('.address-new__inputs');
      if (formInputs) {
        formInputs.insertBefore(errorContainer, formInputs.firstChild);
      }
    }

    errorContainer.textContent = message;
    errorContainer.style.display = 'block';

    setTimeout(() => {
      errorContainer.style.display = 'none';
    }, 3000);
  }
}

customElements.define("account-address-popups", AccountAddressPopups);
